import React from "react";

const Pay = () => {
  return (
    <div>
      <h2>Payment System Commint Soon :)</h2>
    </div>
  );
};

export default Pay;
